<template>
  <div>
    <headers :tabIndex="1"></headers>
    <div class="news-banner">
        <div class="news-title">长期聚焦预应力的研究实践</div>
      <div class="news-detail">至善、使命、热爱、专注、硬科技，传递交达价值</div>
    </div>
    <div class="new-box">
      <div class="new-header-img" style="cursor: pointer" v-for="item in newList" @click="toPage(item)">
        <img :src="item.cover" style="width:100%;height: 4.4rem;object-fit: cover" />
        <div class="new-header-img-title">
          <p>{{item.title}}</p>
          <p class="p1" style="margin-top: 0.2rem">发布时间：{{item.publishDate}}</p>
        </div>
      </div>
    </div>
    <footers></footers>
  </div>
</template>


<script>
  import headers from "@/components/wap/header1"
  import footers from "@/components/wap/footer"
  import axios from "axios";
  export default {
    name: 'wapNews',
    components:{headers,footers},
    data() {
      return{
        newList:[],
        selectIndex1:1,
      }
    },
    mounted() {
      this.getNewsList()
    },
    beforeDestroy() {
    },
    methods:{
      toPage(data){
        if(data.type=='outer'){
          window.open(data.url)
        }else if(data.type=='inner'){
          this.$router.push({
            path:'/newsDetail',
            query:{
              id:data.id
            }
          })
        }
      },
      getNewsList(){
        axios.get(this.pageUrl+`/news/page?pageNo=${this.selectIndex1}&pageSize=6`).then(res=>{
          this.pageIndex1=res.data.data.pages;
          this.newList=res.data.data.list
        })
      }
    }
  }
</script>

<style scoped>
  .news-banner{
    width: 100%;
    height: 13.34rem;
    padding-top: 1rem;
    background-image: url("../../assets/imgs/wap/7.png");
    background-size: cover;
  }
  .news-banner .news-title{
    font-size: 0.48rem;
    font-family: PingFang SC-Heavy, PingFang SC;
    font-weight: 800;
    color: #19203B;
    padding:0 0.68rem;
    animation-name: fadeInUp;

    animation-duration:1s;
    animation-timing-function:ease;
    animation-fill-mode:forwards;
    margin-top: 1.34rem;
  }
  .news-banner .news-detail{
    width: 5rem;
    margin: 0.8rem 0;
    font-size: 0.28rem;
    padding:0 0.68rem;
    animation-duration:1s;    opacity: 0;
    animation-timing-function:ease;
    animation-fill-mode:forwards;
    animation-name: fadeInUp;
    animation-delay: 1s;
    font-family: PingFang SC-Regular, PingFang SC;
    font-weight: 400;
    color: #19203B;
  }

  .new-box{
    font-size: 14px;
    font-family: PingFang SC-Regular, PingFang SC;
    font-weight: 400;
    color: #19203B;
  }
  .new-box{
    padding: 0.4rem 0.72rem;
  }
  .new-box .new-header-img{
    width: 6.04rem;
    object-fit: cover;
    margin-bottom: 0.4rem;
  }
 .new-box .new-header-img-title{
    font-size: 0.3rem;
    font-family: PingFang SC-Bold, PingFang SC;
    font-weight: bold;
    color: #19203B;
  }
  .new-box .new-header-img-title .p1{
    font-size: 0.24rem;
    font-family: PingFang SC-Regular, PingFang SC;
    font-weight: 400;
    color: #5C5D5F;
  }
</style>



// WEBPACK FOOTER //
// src/view/news/wapIndex.vue